import React from 'react';


class ModalPlaceOrderWithReplace extends React.Component {

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });
    }


    backResultPage = () => {
        this.props.setModalOrderWithReplaceClosed();
    }


    setModalOrderWithReplaceClosed = () =>  {
        this.props.setModalOrderWithReplaceClosed();
    }

    setModalOrderWithReplaceOpened = () =>  {
        this.props.setModalOrderWithReplaceOpened();
    }
    

    DisplayForOrderWithReplace =() => {
        let data = this.props.placeOrderData;
        data.replaceOrder = 1;
        this.props.DisplayForOrderWithReplace(data);
    }

  render() {


    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderWithReplaceClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                    <div className="modal_order_top">                            
                                        <div className="modal_order_title1">אישור החלפת הזמנה</div>
                                    </div>


                                    <div className="modal_order_title_hotel directionRtl">
                                    
                                    </div>


                                        <div className="cntered-flex order_cancel_text directionRtl">
                                            קיימת הזמנה במערכת לשנת זכאות זו.
                                            <br />
                                            האם ברצונך לבטל הזמנה זו ולבצע הזמנה חדשה במקומה?
                                        </div>  
                                    


                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button2"
                                                onClick={() => this.DisplayForOrderWithReplace()}>
                                            <span className="hp_search_main_button_title">
                                            ! בצע הזמנה חדשה
                                            </span>
                                        </div>
                                    </div>
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button2"
                                                onClick={() => this.backResultPage()}>
                                            <span className="hp_search_main_button_title">
                                            השאר הזמנה קיימת
                                            </span>
                                        </div>
                                    </div>      
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default ModalPlaceOrderWithReplace;